export enum MailSettingsFormSubmitMode {
  TEST = "test",
  SAVE = "save"
}
